import { lazy } from "react";

// Lazy-loaded view components
export const English = lazy(() => import("../views/English"));
export const ListPodcastView = lazy(() => import("../views/ListPodcastView"));
export const TopListPodcastView = lazy(() => import("../views/TopListPodcastView"));
export const FindView = lazy(() => import("../views/FindView"));
export const PolicyView = lazy(() => import("../views/PolicyView"));
export const AboutView = lazy(() => import("../views/AboutView"));
export const SubjectListView = lazy(() => import("../views/SubjectListView"));
export const SubjectView = lazy(() => import("../views/SubjectView"));
export const PodcastView = lazy(() => import("../views/PodcastView"));
export const EpisodeView = lazy(() => import("../views/EpisodeView"));
export const PodcastSeasonView = lazy(() => import("../views/PodcastSeasonView"));
export const AuthorView = lazy(() => import("../views/AuthorView"));
export const CollectionView = lazy(() => import("../views/CollectionView"));
export const CollectionList = lazy(() => import("../views/CollectionList"));
export const Categories = lazy(() => import("../views/Categories"));
export const Category = lazy(() => import("../views/Category"));
